import React from 'react';

const FileFilledIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.16711 2.22217H5.83312C4.75923 2.22217 3.88867 3.09272 3.88867 4.16661V15.8333C3.88867 16.9072 4.75923 17.7777 5.83312 17.7777H14.1665C15.2403 17.7777 16.1109 16.9072 16.1109 15.8333V9.11662H10.9767C9.98006 9.11662 9.17192 8.30911 9.17113 7.31249L9.16711 2.22217ZM6.69425 14.4444C6.69425 13.9074 7.12953 13.4722 7.66648 13.4722H12.3331C12.8701 13.4722 13.3053 13.9074 13.3053 14.4444C13.3053 14.9813 12.8701 15.4166 12.3331 15.4166H7.66648C7.12953 15.4166 6.69425 14.9813 6.69425 14.4444Z"
      fill="currentColor"
    />
    <path
      d="M15.7928 7.72773H10.9767C10.7467 7.72773 10.5602 7.54138 10.56 7.31139L10.5562 2.50913C10.6853 2.58829 10.8057 2.68287 10.9145 2.79168L15.5414 7.41859C15.6363 7.51348 15.7203 7.61716 15.7928 7.72773Z"
      fill="currentColor"
    />
  </svg>
);

export default FileFilledIcon;
